<template>
  <div class="page">
    <mt-header fixed title="创建合约">
      <mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
    </mt-header>
    <div class="container">
      <p class="note">创建成功之后您所创建的Token将全部发往您的ETH地址中</p>
      <coin-picker v-model="coin" />
      <div class="form">
        <div class="field-group">
          <div class="field-label">总量</div>
          <div class="field-value">
            <input
              type="text"
              v-model="form.total_supply"
              class="input"
              placeholder="totally supply: eg 210000000"
            />
          </div>
        </div>
        <div class="field-group">
          <div class="field-label">名称(大小写字母，空格)</div>
          <div class="field-value">
            <input type="text" v-model="form.name" class="input" placeholder="name: eg HMC Pro" />
          </div>
        </div>
        <div class="field-group">
          <div class="field-label">单位</div>
          <div class="field-value">
            <input
              type="text"
              v-model="form.decimals"
              class="input"
              placeholder="decimal places: eg 18"
            />
          </div>
        </div>
        <div class="field-group">
          <div class="field-label">符号(大写字母)</div>
          <div class="field-value">
            <input type="text" v-model="form.symbol" class="input" placeholder="symbol: eg HMC" />
          </div>
        </div>
        <div class="field-group">
          <div class="field-label">图标</div>
          <div class="field-value">
            <div class="upload-wrap">
              <img v-if="showIcon" :src="showIcon" />
              <span v-else class="upload-inner">+</span>
              <input type="file" @change="onFileChange($event)" class="upload-file" />
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="btn" @click="handleOrder">创建</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import CoinPicker from '@/components/CoinPicker'
import { httpCreateTokenOrder } from '@/api/token'
import { httpUpload } from '@/api/userCenter'
export default {
  components: { CoinPicker },
  data() {
    return {
      coin: '',
      form: {
        name: '',
        symbol: '',
        icon: '',
        total_supply: '',
        decimals: '',
      },
      showIcon: '',
    }
  },
  methods: {
    handleOrder() {
      MessageBox.confirm('确定执行此操作?')
        .then((action) => {
          Indicator.open()
          httpCreateTokenOrder(this.form).then(({ msg }) => {
            Toast(msg)
          })
        })
        .catch((action) => {})
    },
    onFileChange(e) {
      const file = e.target.files[0]
      let formData = new FormData()
      formData.append('file', file)
      httpUpload(formData)
        .then(({ msg }) => {
          this.form.icon = res.data.url
          this.showIcon = res.data.http_url
          Toast(msg)
        })
        .catch(() => {})
    },
  },
}
</script>
<style scoped>
.mint-header {
  background-color: #ffffff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.page {
  padding-top: 40px;
  background-color: #eee;
  height: 100vh;
}
.container {
  padding: 10px;
  height: calc(100vh - 100px);
  overflow: auto;
}
.note {
  font-size: 12px;
  height: 30px;
  line-height: 30px;
}
.form {
  margin-top: 10px;
  background-color: white;
  border-radius: 6px;
  padding: 10px 20px;
}
.field-group {
  padding: 2px;
  margin-bottom: 10px;
}
.field-label {
  font-size: 14px;
}
.field-value {
  margin-top: 6px;
  padding: 2px 4px;
}
.field-value .input {
  display: block;
  height: 40px;
  border-radius: 4px;
  background-color: #eee;
  width: 100%;
  padding: 0 6px;
  box-sizing: border-box;
}
.footer {
  padding: 10px 35px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
}
.btn {
  height: 40px;
  line-height: 40px;
  background-color: #1296db;
  color: white;
  text-align: center;
  border-radius: 4px;
}

.upload-wrap {
  width: 80px;
  height: 80px;
  border-radius: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eee;
  position: relative;
}
.upload-wrap img {
  width: 100%;
}
.upload-inner {
  font-size: 30px;
}
.upload-file {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
  z-index: 1;
}
</style>